// ============================================================
// ANRIB THEME JS — Cart Drawer, ATC, Mobile Nav, Scroll Reveal
// ============================================================

// Utility: format price in INR
function formatPrice(cents) {
  return '₹' + (cents / 100).toLocaleString('en-IN');
}

// ── CART STATE ──────────────────────────────────────────────
async function fetchCart() {
  const res = await fetch('/cart.js');
  return res.json();
}

async function renderCartDrawer() {
  const cart = await fetchCart();
  const body = document.getElementById('cart-drawer-body');
  const footer = document.getElementById('cart-drawer-footer');
  const subtotalEl = document.getElementById('cart-subtotal');
  const countEls = document.querySelectorAll('.cart-count');

  // Update badge
  countEls.forEach(el => {
    el.textContent = cart.item_count;
    el.style.display = cart.item_count > 0 ? 'flex' : 'none';
  });

  if (cart.item_count === 0) {
    body.innerHTML = '<div class="cart-drawer__empty"><p style="font-size:16px;color:#555;margin-bottom:8px">Your cart is empty</p><a href="/collections/all" style="color:#1B6B28;text-decoration:underline;font-size:14px">Continue Shopping →</a></div>';
    footer.style.display = 'none';
    return;
  }

  footer.style.display = 'block';
  subtotalEl.textContent = formatPrice(cart.total_price);

  body.innerHTML = cart.items.map(item => `
    <div class="cart-item" data-key="${item.key}">
      <img class="cart-item__img" src="${item.image}" alt="${item.title}" loading="lazy">
      <div class="cart-item__info">
        <div class="cart-item__title">${item.product_title}</div>
        <div class="cart-item__price">${formatPrice(item.line_price)}</div>
        <div style="display:flex;align-items:center;gap:12px;margin-top:8px">
          <div style="display:flex;align-items:center;border:1px solid #D9EDD9;border-radius:4px;overflow:hidden">
            <button onclick="updateQty('${item.key}', ${item.quantity - 1})" style="width:28px;height:28px;font-size:16px;display:flex;align-items:center;justify-content:center;cursor:pointer;border:none;background:#f5f5f5">−</button>
            <span style="width:32px;text-align:center;font-size:14px;font-weight:600">${item.quantity}</span>
            <button onclick="updateQty('${item.key}', ${item.quantity + 1})" style="width:28px;height:28px;font-size:16px;display:flex;align-items:center;justify-content:center;cursor:pointer;border:none;background:#f5f5f5">+</button>
          </div>
          <span class="cart-item__remove" onclick="removeItem('${item.key}')">Remove</span>
        </div>
      </div>
    </div>
  `).join('');
}

async function updateQty(key, qty) {
  if (qty < 1) { removeItem(key); return; }
  await fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: qty })
  });
  renderCartDrawer();
}

async function removeItem(key) {
  await fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: 0 })
  });
  renderCartDrawer();
}

// ── OPEN / CLOSE CART DRAWER ────────────────────────────────
function openCartDrawer() {
  document.getElementById('cart-drawer').classList.add('active');
  document.getElementById('cart-overlay').classList.add('active');
  document.body.style.overflow = 'hidden';
  renderCartDrawer();
}
function closeCartDrawer() {
  document.getElementById('cart-drawer').classList.remove('active');
  document.getElementById('cart-overlay').classList.remove('active');
  document.body.style.overflow = '';
}

document.addEventListener('DOMContentLoaded', () => {
  document.getElementById('cart-drawer-close')?.addEventListener('click', closeCartDrawer);
  document.getElementById('cart-overlay')?.addEventListener('click', closeCartDrawer);

  // ── BUY NOW — clears cart, adds item, goes directly to checkout ──
  document.querySelectorAll('[data-buynow]').forEach(btn => {
    btn.addEventListener('click', async (e) => {
      e.preventDefault();
      const variantId = btn.dataset.variantId;
      const qtyInput = document.getElementById('qty-input');
      const qty = qtyInput ? parseInt(qtyInput.value) || 1 : 1;
      const original = btn.textContent;
      btn.textContent = 'Processing...';
      btn.disabled = true;
      try {
        await fetch('/cart/clear.js', { method: 'POST' });
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: qty })
        });
        window.location.href = '/checkout';
      } catch(err) {
        console.error(err);
        btn.textContent = original;
        btn.disabled = false;
      }
    });
  });

  // ── ADD TO CART (collection page, product cards) ────────────
  document.querySelectorAll('[data-atc]').forEach(btn => {
    btn.addEventListener('click', async (e) => {
      e.preventDefault();
      const variantId = btn.dataset.variantId;
      if (!variantId) return;
      const original = btn.textContent;
      btn.textContent = 'Adding...';
      btn.disabled = true;
      try {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        });
        btn.textContent = 'Added ✓';
        setTimeout(() => {
          btn.textContent = original;
          btn.disabled = false;
        }, 1500);
        openCartDrawer();
      } catch(err) {
        console.error(err);
        btn.textContent = 'Try Again';
        btn.disabled = false;
      }
    });
  });

  // Mobile nav is handled by the header section's own inline JS

  // ── STICKY HEADER SHADOW ────────────────────────────────────
  const header = document.querySelector('.anrib-header');
  if (header) {
    window.addEventListener('scroll', () => {
      header.classList.toggle('scrolled', window.scrollY > 10);
    }, { passive: true });
  }

  // ── SCROLL REVEAL ───────────────────────────────────────────
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('revealed'); observer.unobserve(e.target); } });
  }, { threshold: 0.1 });
  document.querySelectorAll('[data-reveal]').forEach(el => observer.observe(el));

  // ── CART ICON ───────────────────────────────────────────────
  document.querySelectorAll('[data-open-cart]').forEach(el => {
    el.addEventListener('click', e => { e.preventDefault(); openCartDrawer(); });
  });

  // Initial cart count
  fetchCart().then(cart => {
    document.querySelectorAll('.cart-count').forEach(el => {
      el.textContent = cart.item_count;
      el.style.display = cart.item_count > 0 ? 'flex' : 'none';
    });
  });

  // ── PRODUCT QUANTITY SELECTOR ───────────────────────────────
  document.getElementById('qty-minus')?.addEventListener('click', () => {
    const inp = document.getElementById('qty-input');
    if (inp && parseInt(inp.value) > 1) inp.value = parseInt(inp.value) - 1;
  });
  document.getElementById('qty-plus')?.addEventListener('click', () => {
    const inp = document.getElementById('qty-input');
    if (inp) inp.value = parseInt(inp.value) + 1;
  });

  // Accordion is handled by the product page section's own inline JS
});
